<template>

<!-- Main container -->

<div class="container">
  <section class="hero">
  <div class="hero-body">
    <div class="container">
      <h1 class="title">
        認定NPO法人日本再生プログラム推進フォーラム
      </h1>
      <h2 class="subtitle">
        クレジットカード支払いフォーム
      </h2>
    </div>
  </div>
</section>
  <section>

      <div class="columns is-mobile is-centered">

        <div class="column is-four-fifths">
            <p>
NPO法人日本再生プログラム推進フォーラムの年会費お支払いフォームです。<br>
この通信は暗号化され、クレジットカード情報は決済会社にのみ送信されます。

    </p>

<hr>

      <form id="form">
            <b-field v-bind:label="items.name.label">
                <b-input v-model="name" required class="input-middle"  placeholder="お名前または法人名を入力してください"></b-input>
            </b-field>
        
        <b-field v-bind:label="items.email.label">
                  <b-input v-model="email" required type="email"   placeholder="メールアドレスを入力してください" class="input-middle"></b-input>
        </b-field>

        <b-field v-bind:label="items.tel.label">
            <b-input  v-model="tel"  type="text"  required class="input-middle"></b-input>
        </b-field>


        <b-field v-bind:label="items.member_type.label" >
            <b-select v-model="member_type"  required placeholder="選択してください">
                <option value="0">個人正会員</option>
                <option value="1">個人賛助会員</option>
                <option value="10">法人正会員</option>
                <option value="11">法人賛助会員</option>
            </b-select>
        </b-field>

            <b-field label="年会費" >
                <p>
                     {{member_price}}
                </p>            
    </b-field>


                <b-field label="寄付金"   message="同時にご寄付がある場合のみご入力ください" >
                    
            <b-input  v-model="donation"  placeholder="数字のみ入力してください" type="number" class="input-small"></b-input>
             
        </b-field>




                <span v-if="member_type">
                    上記金額をクレジットカードで支払いします。
                    </span>    
       

  <b-field  label="ご質問、ご要望" >
            <b-input type="textarea"
                v-model="description"  
                maxlength="1000"
                class="input-middle"
                placeholder="NSPへご質問、ご要望がございましたらこちらにご記入ください">
            </b-input>
        </b-field>


<hr>


    <img src="./assets/card.jpg" width="200">
       <b-field class="input-middle" v-bind:label="items.card_name.label" >
            <b-input v-model="card_name" required placeholder="アルファベットで入力してください"></b-input>
        </b-field>        

       <b-field class="input-small" v-bind:label="items.card_number.label" >
            <b-input v-model="card_number" required placeholder="数字のみで入力してください"></b-input>
        </b-field>        

   <b-field grouped>
        <b-field  v-bind:label="items.card_exp_m.label" required >
            <b-select v-model="card_exp_m" >
                <option>01</option>
                <option>02</option>
                <option>03</option>
                <option>04</option>
                <option>05</option>
                <option>06</option>
                <option>07</option>
                <option>08</option>
                <option>09</option>
                <option>10</option>
                <option>11</option>
                <option>12</option>
            </b-select>
        </b-field>
        <b-field v-bind:label="items.card_exp_y.label" required >
            <b-select v-model="card_exp_y" >
                 <option v-for="n in 12" :value="n - 1 + year + 2000" >
                    {{ n - 1 + year  }}
                 </option>
            </b-select>
        </b-field>
    
    </b-field>

        <b-field v-bind:label="items.card_sec.label" message="VISA,Master,JCBは裏面の３桁、AMEXは面面の４桁のコード<i id='modal_on' class='fa fa-info-circle'></i>">
            <b-input v-model="card_sec" required class="input-tiny"></b-input>
        </b-field>   

        <div class="modal" id="modal">
  <div class="modal-background"></div>
  <div class="modal-content">
    <p class="image">
      <img src="./assets/img02.jpg" alt="">
    </p>
  </div>
  <button class="modal-close is-large" aria-label="close" onclick="document.getElementById('modal').classList.toggle('is-active');"></button>
</div>

  <br>
    <b-field ><!-- Label left empty for spacing -->
    <div class="field">
            <p class="control">
                <button class="button is-primary" v-bind:disabled="isPush" @click="exec">
                  支払い
                </button>
            </p>
            </div>
        </b-field>
      <br>
    
          </form>
  </div>

</div>
    </section>
  
 
  <footer class="footer">
  <div class="content has-text-centered">
     

    <p>
             
&copy; 認定NPO法人日本再生プログラム推進フォーラム　<br>

    </p>
  </div>
</footer>
</div>


</template>

<script>
import axios from 'axios';

export default {
  name: 'app',
 
  data () {
    return {       
        name: '',
        email: '',
        tel: '',
        card_name: '',
        card_number: '',
        card_exp_m: '',
        card_exp_y: '',
        card_sec: '',
        member_type: '' ,    
        donation: '',
        description: '',
        price_table: {'0': '10,000円','1': '5,000円','10': '20,000円','11': '7,000円'},     
        year:  new Date().getYear() - 100,
        errors: {},
        items: {
            name: {label: 'お名前'},
            email: {label: 'メールアドレス'},
            tel: {label: '電話番号'},            
            member_type: {label: '会員種別'},            
            card_name: {label: 'クレジットカードのお名前'},
            card_number: {label: 'クレジットカード番号'},
            card_exp_m: {label: '有効期限(月)'},
            card_exp_y: {label: '有効期限(年)'},
            card_sec: {label: 'セキュリティコード'},       
            donation: {label: '寄付金'},         
        },
         isPush : false,
         loading: false
    }
  },
   
 methods: {
    loading_open() {
                this.loading = this.$loading.open({
                  
                })
               
            },
    loading_close(){
        this.loading.close();
    },
    redirect: function(){
         location.href  = "/";
    },
    exec: function () {

     
      // 本来はajax通信をする
      const $form = document.getElementById('form');
      $form.addEventListener('submit', (e) => {
              e.preventDefault();
            // $form.submit(); or ajaxする など
      });

      const isValid = $form.checkValidity();

      if(isValid){          
        this.isPush = true;     
       
        // AJAX     
        var card = {
            name: this.card_name,
            number: this.card_number,
            cvc: this.card_sec,
            exp_month: this.card_exp_m,
            exp_year: String(this.card_exp_y)
        };

        Payjp.createToken(card, function(status, response) {
            if (status == 200) {
                console.log(response);
                // handle token object and send back to your server. You can get token id from "response.id".
            let params = {
                name: this.name,
                card_name: this.card_name,
                email: this.email,
                tel: this.tel,
                member_type: this.member_type,
                donation: this.donation,
                description: this.description,
                token: response.id                            
            };

            var t = location.search.substring(1).split('=')
            if(t[0] == 'test'){
                params.test = true;
            }

            if(window.confirm('送信します')){
            this.loading_open();

            axios.post('https://nipponsaisei.jp/payment',params)
            //axios.post('http://localhost:3000/payment',params)
                .then(function(res){
    　　　　　　　//vueにバインドされている値を書き換えると表示に反映される
                console.log(res)
                this.loading_close();
                this.$dialog.alert({
                    title: '',
                    hasIcon: true,                   
                    message: 'お支払いが完了しました',
                    confirmText: 'OK',
                    icon: 'check-square',
                    iconPack: 'fa',
                    type: 'is-success',
                    onConfirm: () => this.redirect()
                })
                  }.bind(this))
                .catch(function(res){       
                      this.loading_close();            
                    //vueにバインドされている値を書き換えると表示に反映される
                this.$dialog.alert({
                    title: 'エラー',
                    message: 'システムエラー',
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa'
                });
           
                }.bind(this))
            }else{            
                this.isPush = false;  
               
            }

            } else {
                // handle error like displaying error message.
                console.log('error');    
            
                let error = 'カード情報を確認して下さい';
                if(response.error.code == 'card_declined'){
                    error = 'このカードはご利用できません(利用不可)';
                }else if(response.error.code == 'expired_card'){
                    error = 'このカードはご利用できません（有効期限切れ）';
                }else if(response.error.code == 'invalid_cvc'){
                     error = 'セキュリティコードを確認してください';
                }else if(response.error.code == 'processing_error'){
                    error = 'プロセスエラー　もう一度入力してください';
                }else{
                    error =  'エラー: ' + response.error.code;
                };
                this.isPush = false;   

                this.$dialog.alert({
                    title: 'エラー',
                    message: error,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa'
                })
                this.isPush = false;     
            };
        }.bind(this));
      }else{
            this.isPush = false;     
      }
      

    },
    modal(){       
         this.$modal.open(
                    `<p class="image is-4by3">
                        <img src="./assets/img02.jpg">
                    </p>`
                )

    }
 },
  computed: {
    member_price:  function () {
         return this.price_table[this.member_type];
    }
  },

  mounted:  function () {

   
document.getElementById('modal_on').addEventListener('click', function(event) {
  event.preventDefault();
  var modal = document.querySelector('.modal');  // assuming you have only 1
  var html = document.querySelector('html');
  modal.classList.add('is-active');
  html.classList.add('is-clipped');
  });

    var modal = document.querySelector('.modal');  // assuming you have only 1
    var html = document.querySelector('html');
    
    modal.querySelector('.modal-background').addEventListener('click', function(e) {
        e.preventDefault();
        modal.classList.remove('is-active');
        html.classList.remove('is-clipped');
    });
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.dirty {
    border-color: forestgreen;
    background: mintcream;
}
.error {
    border-color: red;
    background: mistyrose;
}

@media(max-width:430px){
.input-middle {
    width: 100%;
}
.input-small {
    width: 100%;
}

}

.input-middle {
    width: 20em;
}

.input-small {
    width: 16em;
}

.input-tiny {
    width: 5em;
}

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: $turquoise;
$primary-invert: findColorInvert($primary);
$twitter: #4099FF;
$twitter-invert: findColorInvert($twitter);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    "twitter": ($twitter, $twitter-invert)
);

// Links
//$link: $primary;
//$link-invert: $primary-invert;
//$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

</style>




// WEBPACK FOOTER //
// src/App.vue